module.exports = __webpack_public_path__ + "img/icon-question-arrow-rigth-blue.c5ccd0aa.svg";